import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Detail from './Detail';

export default function MembershipsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={match.url} />
      <Route path={`${match.url}/:topicId`} component={Detail} />
    </Switch>
  );
}
